/** @deprecated: Используете useId() */
export enum IdPrefix {
  TemplateFile = 'tf-',
  ExternalFile = 'ef-',
  UiTab = 'ui-tab-',
  Control = 'control-',
  SchemaControl = 'schema-control-',
  Condition = 'condition-',
}
